import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './oauth-callback.styles'
import Spinner from 'pobble-components/dist/spinner'
import Auth from '../../../../../auth/auth'

const OauthCallback = ({ classes, onMount }) => {
  useEffect(
    () => {
      onMount()
    },
    [onMount]
  )
  return (
    <Auth>
      <div className={classes.container}>
        <Spinner />
      </div>
    </Auth>
  )
}

export default injectSheet(styles)(OauthCallback)
